import api from "./axiosInstance";

export const register = async ({email, full_name, password}: {
    email: string,
    full_name: string,
    password: string
}) => {
    const res = await api.post('/method/notes.notes.api.auth.register', {
        email,
        full_name,
        password
    });
    return res.data.message
};


export const login = async ({email, password}: { email: string, password: string }) => {
    const res = await api.post('/method/login', {
        usr: email,
        pwd: password
    });
    return res.data.message
}
